export enum Brokers {
    Twilio = "ba3a545f-a77d-44bf-8344-ba05f54f5324",
    Positus = "c8ade4e2-993f-42dd-a108-430e9655a10f",
    Meta = "e7fd7160-c9a3-435f-893d-a2d87ede6de5",
    Smarters = "695e98ef-d32c-472f-aa66-8bc26510eac5"
}